module.exports = __webpack_public_path__ + "media/images/vp/icon.rt.red-12fbed371e6755ae3530d5c1f16a9917.png";